import { repository } from '@woc/woc-repository'

import { Address } from '@/model/company'

function createRequest (address, language) {
  return {
    transient: true,
    entity: {
      address,
      language: language || 'en'
    }
  }
}

export const geocodeRepository = repository.create({
  entity: 'geocodeRequest',
  url: 'geocode-requests',
  factory: (data) => new Address(data),
  allow: 'c'
})

export function locate (store, address) {
  return store.dispatch(geocodeRepository.create, createRequest(address))
    .then(a => {
      return a.fullName && store.dispatch(geocodeRepository.create, createRequest(a.fullName, store.state.identity.currentUser.locale))
        .then(localized => {
          a.localized = localized
          return a
        })
    })
}

export default repository.asModule(geocodeRepository)
